module.exports = __webpack_public_path__ + "static/fish-f8823e9334d32d0e52313f9a1ca96120.mp4";